import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from "@material-ui/core";
import LeftControl from '../LeftControl';

const PageLayout = ({ id, className = "Liq-Container", children }) => {
    let { collapse } = useSelector(state => state.utils)

    return (
        <Grid container xs={12} className={className} id={id}>
            <LeftControl />
            <Grid xs={12} md={collapse ? 0 : 10} container justify="center" className="PageContent">
                {children}
            </Grid>
        </Grid>
    )
}

export default PageLayout